<div
  #scrollContainer
  class="unified-feed-scroll"
  [class.px-5]="!nurseNotesTimeline && !fullWidthTimeline"
  [class.unified-feed-scroll--nurse-notes]="nurseNotesTimeline"
  (scroll)="onScroll()"
>
  <ng-template #prospectHistoryMeta let-item="item">
    <small
      *ngIf="timelineItemFooterDateDisplay(item) as when"
      class="unified-date d-block mt-1"
    >
      {{ when }}
      <ng-container *ngIf="timelineItemActorDisplay(item) as actor">
        <span aria-hidden="true"> · </span>{{ actor }}
      </ng-container>
    </small>
  </ng-template>

  <ul
    class="activity-list list-unstyled mb-0 p-0"
    [class.nurse-notes-timeline]="nurseNotesTimeline"
    [class.prospect-history-timeline]="fullWidthTimeline"
    id="unifiedActivityFeed"
  >
    <ng-container *ngFor="let item of filteredItems">
      <!-- Engage Activity: staff/outbound right; patient/inbound left -->
      <li
        *ngIf="item.source === 'engage'"
        class="my-5 engage-timeline-item"
        [class.prospect-history-item]="fullWidthTimeline"
        [class.prospect-history-item--note]="fullWidthTimeline"
        [ngClass]="{'mt-2': $any(item.data).type === 'form_filled'}"
      >
        <ng-container *ngIf="isEngageJoinConversationRow($any(item.data)); else engageStandardRow">
          <div class="unified-feed-join-row w-100 text-center py-2 px-1">
            <span class="small text-muted unified-feed-join-text">
              <span class="unified-feed-join-name">{{ getEngageJoinDisplayName($any(item.data)) }}</span> has joined the conversation<span *ngIf="$any(item.data).createdDateTime || $any(item.data).createdAt">, {{ formatMessageDate(($any(item.data).createdDateTime || $any(item.data).createdAt || '').toString()) }}</span>
            </span>
          </div>
        </ng-container>
        <ng-template #engageStandardRow>
        <ng-container [ngSwitch]="shouldEngageActivityAlignRight($any(item.data))">
          <!-- Right: company user / outbound / clinic-sent -->
          <div *ngSwitchCase="true" class="d-flex flex-column align-items-end">
            <div class="d-flex align-items-start justify-content-end gap-3 w-100">
              <div class="d-flex flex-column align-items-end w-100">
                <span *ngIf="!fullWidthTimeline && ($any(item.data).type === 'reminder' || ($any(item.data).type !== 'form_filled' && $any(item.data).type !== 'drip'))" class="small text-muted d-block mb-1 unified-title text-end w-100" style="min-height:15px">{{ $any(item.data).type === 'reminder' ? getReminderUnifiedTitle($any(item.data)) : ($any(item.data).activityBy || '') }}</span>
                <div
                  class="activity-note-card activity-note-card--right card rounded-3 border p-2 px-3 position-relative m-0"
                  [class.activity-note-card--reminder]="$any(item.data).type === 'reminder'"
                  [class.activity-note-card--reminder-edit]="$any(item.data).type === 'reminder' && editingActivityId === $any(item.data).id"
                >
                  <ng-container *ngIf="$any(item.data).type === 'reminder' && editingActivityId !== $any(item.data).id">
                    <div class="d-flex align-items-center justify-content-between gap-2 w-100">
                      <div class="text-muted small flex-grow-1">
                        <span class="activity-note-tags-inline" [innerHTML]="($any(item.data).notes || '') | activityNoteTagHighlight"></span>
                      </div>
                      <a class="btn-link small text-primary" href="javascript:void(0)" (click)="startEditReminder($any(item.data)); $event.preventDefault()">Edit</a>
                      <!-- <div class="rounded-circle bg-light d-flex align-items-center justify-content-center" style="width:28px;height:28px">
                        <i class="fa-solid fa-bell fa-sm text-muted"></i>
                      </div> -->
                    </div>
                  </ng-container>
                  <div *ngIf="$any(item.data).type === 'reminder' && editingActivityId === $any(item.data).id" class="reminder-edit-inline w-100 d-flex flex-column gap-2">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="fs-6 me-2"><span class="activity-note-tags-inline" [innerHTML]="($any(item.data).notes || '') | activityNoteTagHighlight"></span></span>
                      <div class="d-flex gap-1">
                        <button type="button" class="btn btn-soft-primary btn-sm px-2 py-1" (click)="saveReminder()" title="Save" style="width:30px;height:30px"><i class="fa-solid fa-check fs-5"></i></button>
                        <button type="button" class="btn btn-soft-danger btn-sm px-2 py-1" (click)="cancelEditReminder()" title="Cancel" style="width:30px;height:30px"><i class="fa-solid fa-xmark fs-5"></i></button>
                      </div>
                    </div>
                    <div class="reminder-edit-row d-flex flex-nowrap gap-1 align-items-center w-100" [class.reminder-loading]="loadingReminderDetails">
                      <div *ngIf="loadingReminderDetails" class="text-muted small py-2"><i class="fa-solid fa-spinner fa-spin me-1"></i>Loading reminder details...</div>
                      <ng-container *ngIf="!loadingReminderDetails">
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0">
                          <i class="fa-solid fa-users reminder-field-icon"></i>
                          <select class="form-select form-select-sm reminder-field-input" [(ngModel)]="reminderEditForm.assignedToResourceId">
                            <option [value]="assignedToEveryoneOption.value">{{ assignedToEveryoneOption.displayName }}</option>
                            <option *ngFor="let r of resources" [value]="r.value">{{ r.displayName }}</option>
                          </select>
                        </div>
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0 reminder-date-field">
                          <i class="fa-solid fa-calendar reminder-field-icon"></i>
                          <p-calendar #reminderDateCal [(ngModel)]="reminderEditForm.dueDate" [showIcon]="false" appendTo="body" dateFormat="mm/dd/yy" styleClass="reminder-calendar-field" inputStyleClass="border-0 bg-transparent shadow-none reminder-field-input"></p-calendar>
                          <i class="fa-solid fa-chevron-down reminder-field-caret reminder-caret-clickable" (click)="reminderDateCal.overlayVisible = true" title="Open date picker"></i>
                        </div>
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0 reminder-time-field">
                          <input #reminderTimeInput type="time" class="form-control form-control-sm border-0 bg-transparent shadow-none reminder-field-input pe-0" [(ngModel)]="reminderEditForm.time" />
                          <!-- <i class="fa-solid fa-chevron-down reminder-field-caret reminder-caret-clickable" (click)="openReminderTimePicker()" title="Open time picker"></i> -->
                        </div>
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0">
                          <i class="fa-solid fa-bell reminder-field-icon"></i>
                          <select class="form-select form-select-sm reminder-field-input" [(ngModel)]="reminderEditForm.reminderOption">
                            <option *ngFor="let opt of reminderOptions" [value]="opt.value">{{ opt.label }}</option>
                          </select>
                        </div>
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0">
                          <i class="fa-solid fa-globe reminder-field-icon"></i>
                          <select class="form-select form-select-sm reminder-field-input" [(ngModel)]="reminderEditForm.timezone">
                            <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
                          </select>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <ng-container *ngIf="$any(item.data).type !== 'reminder'">
                    <div class="engage-card-main-row d-flex flex-nowrap align-items-center justify-content-between gap-3 w-100">
                      <div class="engage-card-aside flex-shrink-0 text-start">
                        <div class="d-flex flex-column align-items-start gap-1">
                          <div class="d-flex flex-nowrap align-items-center gap-2" *ngIf="!fullWidthTimeline && ($any(item.data).type === 'form_filled' || engageActivityShowDismissCalls($any(item.data)))">
                            <a class="btn-link small text-primary mb-0 text-nowrap" *ngIf="$any(item.data).type === 'form_filled'" href="javascript:void(0)"
                              (click)="resetNotification($any(item.data)); $event.preventDefault()">
                              {{ $any(item.data).notification === 0 ? 'Notify' : 'Dismiss' }}
                            </a>
                            <a class="btn-link small text-primary mb-0 text-nowrap" *ngIf="engageActivityShowDismissCalls($any(item.data))" href="javascript:void(0)"
                              (click)="resetNotification($any(item.data), 0); $event.preventDefault()">Dismiss</a>
                          </div>
                          <div class="small text-muted fst-italic engage-card-dismissed" *ngIf="engageActivityDismissedByLine($any(item.data))">
                            Dismissed<ng-container *ngIf="getNotificationClearedByDisplay($any(item.data)) as dismissedByLabel">
                              <span> — {{ dismissedByLabel }}</span>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div class="engage-card-primary flex-grow-1 min-w-0 text-end d-flex flex-column align-items-end">
                        <div class="text-muted small d-flex align-items-center gap-1 flex-wrap w-100" *ngIf="shouldShowEngageActivityCard($any(item.data))">
                          <span *ngIf="shouldShowEngageTypeLabel($any(item.data))" class="fs-6 activity-title fw-bold flex-shrink-0">{{ getEngageTypeLabel($any(item.data)) }}:</span>
                          <ng-container *ngIf="$any(item.data).type === 'stage' && $any(item.data).stage">
                            {{ getStageDisplayName($any(item.data).stage) }}
                            <span *ngIf="getEngageActivityCardBody($any(item.data))"> - <span class="activity-note-tags-inline" [innerHTML]="getEngageActivityCardBody($any(item.data)) | activityNoteTagHighlight"></span></span>
                          </ng-container>
                          <ng-container *ngIf="$any(item.data).type !== 'stage'"><span class="activity-note-tags-inline" [innerHTML]="(getEngageActivityCardBody($any(item.data)) || '') | activityNoteTagHighlight"></span></ng-container>
                        </div>
                        <div *ngIf="showCallRecordingPlayer($any(item.data))" class="call-recording-player mt-2" (click)="playOrPauseRecording(getRecordingUrl($any(item.data)))" title="Click to play/pause">
                          <button type="button" class="call-recording-play-btn rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" (click)="playOrPauseRecording(getRecordingUrl($any(item.data))); $event.stopPropagation()">
                            <i class="fa-solid text-white" [ngClass]="isRecordingPlaying(getRecordingUrl($any(item.data))) ? 'fa-pause' : 'fa-play'"></i>
                          </button>
                          <div class="waveform-container">
                            <span *ngFor="let h of waveformHeights" class="wave-bar" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))" [style.height.px]="h"></span>
                            <span class="wave-dot" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                            <span class="wave-dot wave-dot--sm" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                            <span class="wave-dot wave-dot--xs" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                          </div>
                          <span class="call-recording-duration">{{ getRecordingDisplayDuration(getRecordingUrl($any(item.data))) }}</span>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <ng-container
                  *ngIf="fullWidthTimeline; else engageRightDefaultDate"
                  [ngTemplateOutlet]="prospectHistoryMeta"
                  [ngTemplateOutletContext]="{ item: item }"
                ></ng-container>
                <ng-template #engageRightDefaultDate>
                  <small class="unified-date mt-1" *ngIf="timelineItemDateDisplay(item) as when">
                    {{ when }}
                  </small>
                </ng-template>
              </div>
              <div class="activity-avatar my-auto activity-avatar--right rounded-circle bg-soft-primary text-muted d-flex align-items-center justify-content-center flex-shrink-0" [ngClass]="{'align-items-center': showCallRecordingPlayer($any(item.data))}">
                <ng-container
                  *ngTemplateOutlet="
                    unifiedFeedTimelineIcon;
                    context: {
                      iconType: timelineIconType($any(item.data)),
                      iconData: $any(item.data)
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </div>
          <!-- Left: all engage activities (reminders, notes, etc.) -->
          <div *ngSwitchDefault>
            <div class="d-flex align-items-start gap-2" [class.w-80]="engageStandardRowUsesW80($any(item.data))">
              <div *ngIf="!($any(item.data).type === 'reminder' && editingActivityId === $any(item.data).id)" class="activity-avatar rounded-circle bg-soft-primary text-muted d-flex align-items-center justify-content-center flex-shrink-0 my-auto" [ngClass]="{'align-items-center': showCallRecordingPlayer($any(item.data))}">
                <ng-container
                  *ngTemplateOutlet="
                    unifiedFeedTimelineIcon;
                    context: {
                      iconType: timelineIconType($any(item.data)),
                      iconData: $any(item.data)
                    }
                  "
                ></ng-container>
              </div>
              <div class="w-100">
                <span *ngIf="!fullWidthTimeline && $any(item.data).type === 'reminder'" class="unified-title text-muted d-block mb-1" style="min-height:15px">{{ getReminderUnifiedTitle($any(item.data)) }}</span>
                <span *ngIf="!fullWidthTimeline && $any(item.data).type !== 'reminder'" class="unified-title text-muted d-block mb-1" style="min-height:15px">{{ getEngageLeftColumnTitle($any(item.data)) }}</span>
                <div class="activity-note-card activity-note-card--left card rounded-3  mb-0 border p-2 px-3 position-relative m-0"
                  [class.activity-note-card--reminder]="$any(item.data).type === 'reminder'"
                  [class.activity-note-card--reminder-edit]="$any(item.data).type === 'reminder' && editingActivityId === $any(item.data).id"
                  [class.activity-note-card--pinned]="fullWidthTimeline && isHistoryPinned(item)"
                >
                  <ng-container *ngIf="$any(item.data).type === 'reminder' && editingActivityId !== $any(item.data).id">
                    <div class="d-flex align-items-center justify-content-between gap-2 w-100">
                      <div class="text-muted small flex-grow-1">
                        <span class="activity-note-tags-inline" [innerHTML]="($any(item.data).notes || '') | activityNoteTagHighlight"></span>
                      </div>
                      <a class="btn-link small text-primary" href="javascript:void(0)" (click)="startEditReminder($any(item.data)); $event.preventDefault()">Edit</a>
                      <!-- <div class="rounded-circle bg-light d-flex align-items-center justify-content-center" style="width:28px;height:28px">
                        <i class="fa-solid fa-bell fa-sm text-muted"></i>
                      </div> -->
                    </div>
                  </ng-container>
                  <div *ngIf="$any(item.data).type === 'reminder' && editingActivityId === $any(item.data).id" class="reminder-edit-inline w-100 d-flex flex-column gap-2">
                    <div class="d-flex align-items-center justify-content-between">
                      <span class="fs-6 me-2"><span class="activity-note-tags-inline" [innerHTML]="($any(item.data).notes || '') | activityNoteTagHighlight"></span></span>
                      <div class="d-flex gap-1">
                        <button type="button" class="btn btn-soft-primary btn-sm px-2 py-1" (click)="saveReminder()" title="Save"><i class="fa-solid fa-check"></i></button>
                        <button type="button" class="btn btn-soft-danger btn-sm px-2 py-1" (click)="cancelEditReminder()" title="Cancel"><i class="fa-solid fa-xmark"></i></button>
                      </div>
                    </div>
                    <div class="reminder-edit-row d-flex flex-nowrap gap-1 align-items-center w-100" [class.reminder-loading]="loadingReminderDetails">
                      <div *ngIf="loadingReminderDetails" class="text-muted small py-2"><i class="fa-solid fa-spinner fa-spin me-1"></i>Loading reminder details...</div>
                      <ng-container *ngIf="!loadingReminderDetails">
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0" style="width:30%">
                          <i class="fa-solid fa-users reminder-field-icon"></i>
                          <select class="form-select form-select-sm reminder-field-input" [(ngModel)]="reminderEditForm.assignedToResourceId">
                            <option [value]="assignedToEveryoneOption.value">{{ assignedToEveryoneOption.displayName }}</option>
                            <option *ngFor="let r of resources" [value]="r.value">{{ r.displayName }}</option>
                          </select>
                        </div>
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0 reminder-date-field">
                          <i class="fa-solid fa-calendar reminder-field-icon"></i>
                          <p-calendar #reminderDateCal [(ngModel)]="reminderEditForm.dueDate" [showIcon]="false" appendTo="body" dateFormat="mm/dd/yy" styleClass="reminder-calendar-field" inputStyleClass="border-0 bg-transparent shadow-none reminder-field-input px-0"></p-calendar>
                          <i class="fa-solid fa-chevron-down reminder-field-caret reminder-caret-clickable" (click)="reminderDateCal.overlayVisible = true" title="Open date picker"></i>
                        </div>
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0 reminder-time-field">
                          <input #reminderTimeInput type="time" class="form-control form-control-sm border-0 bg-transparent shadow-none reminder-field-input pe-0" [(ngModel)]="reminderEditForm.time" />
                          <!-- <i class="fa-solid fa-chevron-down reminder-field-caret reminder-caret-clickable" (click)="openReminderTimePicker()" title="Open time picker"></i> -->
                        </div>
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0">
                          <i class="fa-solid fa-bell reminder-field-icon"></i>
                          <select class="form-select form-select-sm reminder-field-input" [(ngModel)]="reminderEditForm.reminderOption">
                            <option *ngFor="let opt of reminderOptions" [value]="opt.value">{{ opt.label }}</option>
                          </select>
                        </div>
                        <div class="reminder-dropdown-field badge badge-soft-secondary border-0 rounded-4 flex-grow-1 min-w-0">
                          <i class="fa-solid fa-globe reminder-field-icon"></i>
                          <select class="form-select form-select-sm reminder-field-input" [(ngModel)]="reminderEditForm.timezone">
                            <option *ngFor="let tz of timezones" [value]="tz">{{ tz }}</option>
                          </select>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                  <ng-container *ngIf="$any(item.data).type !== 'reminder'">
                    <div class="engage-card-main-row d-flex flex-nowrap align-items-center justify-content-between gap-3 w-100">
                      <div class="engage-card-primary flex-grow-1 min-w-0">
                        <div class="text-muted small d-flex align-items-center gap-1 flex-wrap min-w-0" *ngIf="shouldShowEngageActivityCard($any(item.data))">
                          <span *ngIf="shouldShowEngageTypeLabel($any(item.data))" class="fs-6 activity-title fw-bold flex-shrink-0">{{ getEngageTypeLabel($any(item.data)) }}:</span>
                          <ng-container *ngIf="$any(item.data).type === 'stage' && $any(item.data).stage">
                            {{ getStageDisplayName($any(item.data).stage) }}
                            <span *ngIf="getEngageActivityCardBody($any(item.data))"> - <span class="activity-note-tags-inline" [innerHTML]="getEngageActivityCardBody($any(item.data)) | activityNoteTagHighlight"></span></span>
                          </ng-container>
                          <ng-container *ngIf="$any(item.data).type !== 'stage'"><span class="activity-note-tags-inline" [innerHTML]="(getEngageActivityCardBody($any(item.data)) || '') | activityNoteTagHighlight"></span></ng-container>
                        </div>
                        <div *ngIf="showCallRecordingPlayer($any(item.data))" class="call-recording-player mt-2" (click)="playOrPauseRecording(getRecordingUrl($any(item.data)))" title="Click to play/pause">
                          <button type="button" class="call-recording-play-btn rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" (click)="playOrPauseRecording(getRecordingUrl($any(item.data))); $event.stopPropagation()">
                            <i class="fa-solid text-white" [ngClass]="isRecordingPlaying(getRecordingUrl($any(item.data))) ? 'fa-pause' : 'fa-play'"></i>
                          </button>
                          <div class="waveform-container">
                            <span *ngFor="let h of waveformHeights" class="wave-bar" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))" [style.height.px]="h"></span>
                            <span class="wave-dot" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                            <span class="wave-dot wave-dot--sm" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                            <span class="wave-dot wave-dot--xs" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                          </div>
                          <span class="call-recording-duration">{{ getRecordingDisplayDuration(getRecordingUrl($any(item.data))) }}</span>
                        </div>
                      </div>
                      <div class="engage-card-aside flex-shrink-0 text-end">
                        <div class="d-flex flex-column align-items-end gap-1">
                          <div class="d-flex flex-nowrap align-items-center gap-2" *ngIf="!fullWidthTimeline && ($any(item.data).type === 'form_filled' || engageActivityShowDismissCalls($any(item.data)))">
                            <a class="btn-link small text-primary mb-0 text-nowrap" *ngIf="$any(item.data).type === 'form_filled'" href="javascript:void(0)"
                              (click)="resetNotification($any(item.data)); $event.preventDefault()">
                              {{ $any(item.data).notification === 0 ? 'Notify' : 'Dismiss' }}
                            </a>
                            <a class="btn-link small text-primary mb-0 text-nowrap" *ngIf="engageActivityShowDismissCalls($any(item.data))" href="javascript:void(0)"
                              (click)="resetNotification($any(item.data), 0); $event.preventDefault()">Dismiss</a>
                          </div>
                          <div class="small text-muted fst-italic engage-card-dismissed" *ngIf="engageActivityDismissedByLine($any(item.data))">
                            Dismissed<ng-container *ngIf="getNotificationClearedByDisplay($any(item.data)) as dismissedByLabel">
                              <span> — {{ dismissedByLabel }}</span>
                            </ng-container>
                          </div>
                        </div>
                      </div>
                      <div
                        *ngIf="fullWidthTimeline"
                        class="dropdown prospect-history-card-menu flex-shrink-0"
                        dropdown
                        container="body"
                        (click)="$event.stopPropagation()"
                      >
                        <button
                          type="button"
                          class="prospect-history-card-menu__btn"
                          dropdownToggle
                          aria-label="More actions"
                        >
                          <i class="fa-solid fa-ellipsis" aria-hidden="true"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                          <li *ngIf="$any(item.data).type === 'form_filled'">
                            <button
                              type="button"
                              class="dropdown-item"
                              (click)="resetNotification($any(item.data)); $event.preventDefault()"
                            >
                              {{ $any(item.data).notification === 0 ? 'Notify' : 'Dismiss' }}
                            </button>
                          </li>
                          <li>
                            <button
                              type="button"
                              class="dropdown-item"
                              (click)="toggleHistoryPin(item)"
                            >
                              {{ isHistoryPinned(item) ? 'Unpin this note' : 'Pin this note' }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <ng-container
                  *ngIf="fullWidthTimeline; else engageLeftDefaultDate"
                  [ngTemplateOutlet]="prospectHistoryMeta"
                  [ngTemplateOutletContext]="{ item: item }"
                ></ng-container>
                <ng-template #engageLeftDefaultDate>
                  <small *ngIf="$any(item.data).createdDateTime" class="unified-date d-block mt-1">
                    {{ $any(item.data).createdDateTime | date: 'MMM dd, yyyy h:mm a' }}
                    <ng-container *ngIf="getEngageLeftColumnTitle($any(item.data))">
                      <span aria-hidden="true"> · </span>{{ getEngageLeftColumnTitle($any(item.data)) }}
                    </ng-container>
                  </small>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
        </ng-template>
      </li>

      <!-- Nurse notes timeline (procedure sidebar) -->
      <li *ngIf="nurseNotesTimeline && item.source === 'activity'" class="nurse-notes-timeline-item">
        <div class="nurse-notes-timeline-row">
          <div class="nurse-notes-rail" aria-hidden="true">
            <span class="nurse-notes-avatar">{{ getNurseNoteInitials($any(item.data)) }}</span>
          </div>
          <div class="nurse-notes-main">
            <span class="nurse-notes-dot" aria-hidden="true"></span>
            <div class="nurse-notes-card">
              <div class="nurse-notes-card-header">
                <div class="nurse-notes-card-header__meta">
                  <span class="nurse-notes-author">{{
                    activityNoteTitleLine($any(item.data)) || ($any(item.data).activityBy || 'Unknown')
                  }}</span>
                  <span class="nurse-notes-sep" aria-hidden="true">|</span>
                  <span class="nurse-notes-date" *ngIf="!isEditingNurseNote($any(item.data))">
                    {{ $any(item.data).createdAt | date: 'dd MMM yyyy HH:mm' }}
                  </span>
                </div>
                <div class="dropdown nurse-notes-card-menu flex-shrink-0" dropdown *ngIf="showActivityNoteEditMenu($any(item.data)) && !isEditingNurseNote($any(item.data))">
                  <button type="button" class="nurse-notes-card-menu-btn" dropdownToggle (click)="$event.stopPropagation()" aria-label="Note options">
                    <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
                  </button>
                  <ul class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                    <li><span class="dropdown-item cursor-pointer" role="button" (click)="editActivityNote($any(item.data))">Edit</span></li>
                    <li><span class="dropdown-item cursor-pointer text-danger" role="button" (click)="removeActivityNote($any(item.data).id)">Delete</span></li>
                  </ul>
                </div>
              </div>
              <ng-container *ngIf="isEditingNurseNote($any(item.data)); else nurseNoteBodyView">
                <div class="nurse-notes-inline-edit">
                  <div class="row g-2 nurse-notes-inline-edit__datetime">
                    <div class="col-6">
                      <label class="form-label nurse-notes-inline-edit__label mb-1" for="nurse-note-edit-date">Date</label>
                      <input
                        type="date"
                        class="form-control form-control-sm nurse-notes-inline-edit__datetime-input"
                        id="nurse-note-edit-date"
                        name="nurse-note-edit-date"
                        [(ngModel)]="editingNurseNoteDate"
                      />
                    </div>
                    <div class="col-6">
                      <label class="form-label nurse-notes-inline-edit__label mb-1" for="nurse-note-edit-time">Time</label>
                      <input
                        type="time"
                        class="form-control form-control-sm nurse-notes-inline-edit__datetime-input"
                        id="nurse-note-edit-time"
                        name="nurse-note-edit-time"
                        [(ngModel)]="editingNurseNoteTime"
                      />
                    </div>
                  </div>
                  <textarea
                    class="form-control nurse-notes-inline-edit__input"
                    [(ngModel)]="editingNurseNoteText"
                    rows="3"
                    autocomplete="off"
                    spellcheck="true"
                    (keydown)="onNurseNoteInlineEditKeydown($event, $any(item.data))"
                  ></textarea>
                  <div class="nurse-notes-inline-edit__actions">
                    <button
                      type="button"
                      class="btn btn-sm nurse-notes-inline-edit__save"
                      [disabled]="savingNurseNoteEdit || !canSaveNurseNoteInlineEdit"
                      (click)="saveNurseNoteInlineEdit($any(item.data))"
                    >
                      <i
                        *ngIf="savingNurseNoteEdit"
                        class="fa-duotone fa-spinner-third fa-spin me-1"
                        aria-hidden="true"
                      ></i>
                      Save
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm nurse-notes-inline-edit__cancel"
                      [disabled]="savingNurseNoteEdit"
                      (click)="cancelNurseNoteInlineEdit()"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </ng-container>
              <ng-template #nurseNoteBodyView>
                <div
                  class="nurse-notes-card-body activity-note-tags-inline"
                  [class.nurse-notes-card-body--status]="isNurseNoteStatusStyle($any(item.data))"
                  [innerHTML]="getNurseNoteBodyText($any(item.data)) | activityNoteTagHighlight"
                ></div>
              </ng-template>
            </div>
          </div>
        </div>
      </li>

      <li *ngIf="nurseNotesTimeline && item.source === 'event'" class="nurse-notes-timeline-item">
        <div class="nurse-notes-timeline-row">
          <div class="nurse-notes-rail" aria-hidden="true">
            <span class="nurse-notes-avatar">{{ getNurseNoteEventInitials($any(item.data)) }}</span>
          </div>
          <div class="nurse-notes-main">
            <span class="nurse-notes-dot" aria-hidden="true"></span>
            <div class="nurse-notes-card">
              <div class="nurse-notes-card-header">
                <div class="nurse-notes-card-header__meta">
                  <span class="nurse-notes-author">{{ getNurseNoteEventAuthor($any(item.data)) }}</span>
                  <span class="nurse-notes-sep" aria-hidden="true">|</span>
                  <span class="nurse-notes-date" *ngIf="getEventDateAndTimeIso($any(item.data)) as eventIso">{{ eventIso | date: 'dd MMM yyyy HH:mm' }}</span>
                </div>
              </div>
              <div class="nurse-notes-card-body nurse-notes-card-body--status activity-note-tags-inline">
                {{ getEventTypeDisplay($any(item.data)) }}
              </div>
            </div>
          </div>
        </div>
      </li>

      <!-- Activity Note: referral created + company user notes on right -->
      <li
        *ngIf="!nurseNotesTimeline && item.source === 'activity'"
        class="my-5"
        [class.prospect-history-item]="fullWidthTimeline"
        [class.prospect-history-item--note]="fullWidthTimeline"
      >
        <ng-container [ngSwitch]="activityNoteTimelineSide($any(item.data))">
          <div *ngSwitchCase="'right'" class="d-flex flex-column align-items-end">
            <div class="d-flex align-items-start justify-content-end gap-2 w-100">
              <div class="d-flex flex-column align-items-end w-80">
                <span
                  *ngIf="activityNoteTitleLine($any(item.data)) as titleLine"
                  class="unified-title text-muted d-block mb-1 text-end w-100"
                  style="min-height:15px"
                  >{{ titleLine }}</span
                >
                <div class="activity-note-card activity-note-card--right card rounded-3  border p-2 px-3 position-relative m-0">
                  <div class="d-flex align-items-center justify-content-between gap-2 w-100">
                    <span class="d-flex align-items-center gap-1 flex-grow-1 min-w-0">
                      <div
                        class="text-muted small d-flex flex-column align-items-start gap-1 min-w-0"
                        *ngIf="shouldShowActivityNoteCard($any(item.data))"
                      >
                        <span
                          *ngIf="shouldShowActivityNoteTypeLabel($any(item.data))"
                          class="fs-6 activity-title fw-bold"
                          >{{ getActivityNoteTypeLabel($any(item.data).activityType) }}:</span
                        >
                        <span
                          class="activity-note-tags-inline"
                          [innerHTML]="(getActivityNoteCardBody($any(item.data)) || '') | activityNoteTagHighlight"
                        ></span>
                      </div>
                    </span>
                    <div class="dropdown flex-shrink-0" dropdown container="body" *ngIf="fullWidthTimeline || showActivityNoteEditMenu($any(item.data))">
                      <button type="button" class="btn btn-link p-0 text-muted prospect-history-card-menu__btn" dropdownToggle (click)="$event.stopPropagation()" aria-label="More actions">
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                        <li *ngIf="fullWidthTimeline">
                          <button type="button" class="dropdown-item" (click)="toggleHistoryPin(item)">
                            {{ isHistoryPinned(item) ? 'Unpin this note' : 'Pin this note' }}
                          </button>
                        </li>
                        <li *ngIf="showActivityNoteEditMenu($any(item.data))"><span class="dropdown-item cursor-pointer" role="button" (click)="editActivityNote($any(item.data))">Edit</span></li>
                        <li *ngIf="showActivityNoteEditMenu($any(item.data))"><span class="dropdown-item cursor-pointer text-danger" role="button" (click)="removeActivityNote($any(item.data).id)">Delete</span></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <ng-container
                  *ngIf="fullWidthTimeline; else activityNoteRightDefaultDate"
                  [ngTemplateOutlet]="prospectHistoryMeta"
                  [ngTemplateOutletContext]="{ item: item }"
                ></ng-container>
                <ng-template #activityNoteRightDefaultDate>
                  <small class="text-muted mt-1">
                    {{ $any(item.data).createdAt | date: 'EEE, MMM d, y, h:mm a' }}
                  </small>
                </ng-template>
              </div>
              <div class="activity-avatar my-auto activity-avatar--right rounded-circle bg-soft-primary text-muted d-flex align-items-center justify-content-center flex-shrink-0">
                <ng-container
                  *ngTemplateOutlet="
                    unifiedFeedTimelineIcon;
                    context: {
                      iconType: timelineIconType($any(item.data)),
                      iconData: $any(item.data)
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </div>
          <div *ngSwitchDefault>
            <div class="d-flex align-items-start gap-2">
              <div class="activity-avatar my-auto rounded-circle bg-soft-primary text-muted d-flex align-items-center justify-content-center flex-shrink-0">
                <ng-container
                  *ngTemplateOutlet="
                    unifiedFeedTimelineIcon;
                    context: {
                      iconType: timelineIconType($any(item.data)),
                      iconData: $any(item.data)
                    }
                  "
                ></ng-container>
              </div>
              <div class="flex-grow-1">
                <span
                  *ngIf="activityNoteTitleLine($any(item.data)) as titleLine"
                  class="unified-title text-muted d-block mb-1"
                  style="min-height:15px"
                  >{{ titleLine }}</span
                >
                <div class="activity-note-card activity-note-card--left card rounded-3 mb-0 border p-2 px-3">
                  <div class="d-flex align-items-center justify-content-between gap-2 w-100">
                    <span class="d-flex align-items-start gap-1 flex-grow-1 min-w-0">
                      <div class="text-muted small">
                        <span
                          class="activity-note-tags-inline"
                          [innerHTML]="($any(item.data).notes || $any(item.data).activityType || '') | activityNoteTagHighlight"
                        ></span>
                      </div>
                    </span>
                    <div class="dropdown flex-shrink-0" dropdown container="body" *ngIf="fullWidthTimeline || showActivityNoteEditMenu($any(item.data))">
                      <button type="button" class="btn btn-link p-0 text-muted prospect-history-card-menu__btn" dropdownToggle (click)="$event.stopPropagation()" aria-label="More actions">
                        <i class="fa-solid fa-ellipsis"></i>
                      </button>
                      <ul class="dropdown-menu dropdown-menu-end" *dropdownMenu>
                        <li *ngIf="fullWidthTimeline">
                          <button type="button" class="dropdown-item" (click)="toggleHistoryPin(item)">
                            {{ isHistoryPinned(item) ? 'Unpin this note' : 'Pin this note' }}
                          </button>
                        </li>
                        <li *ngIf="showActivityNoteEditMenu($any(item.data))"><span class="dropdown-item cursor-pointer" role="button" (click)="editActivityNote($any(item.data))">Edit</span></li>
                        <li *ngIf="showActivityNoteEditMenu($any(item.data))"><span class="dropdown-item cursor-pointer text-danger" role="button" (click)="removeActivityNote($any(item.data).id)">Delete</span></li>
                      </ul>
                    </div>
                  </div>
                </div>
                <ng-container
                  *ngIf="fullWidthTimeline; else activityNoteLeftDefaultDate"
                  [ngTemplateOutlet]="prospectHistoryMeta"
                  [ngTemplateOutletContext]="{ item: item }"
                ></ng-container>
                <ng-template #activityNoteLeftDefaultDate>
                  <small class="text-muted d-block mt-1">
                    {{ $any(item.data).createdAt | date: 'EEE, MMM d, y, h:mm a' }}
                  </small>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
      </li>

      <!-- SMS: received on left, sent/outbound on right, join centered -->
      <li
        *ngIf="item.source === 'sms'"
        class="my-5"
        [class.prospect-history-item]="fullWidthTimeline"
        [class.prospect-history-item--note]="fullWidthTimeline"
      >
        <ng-container [ngSwitch]="smsTimelineSide($any(item.data))">
          <!-- Right: sent/outbound -->
          <div *ngSwitchCase="'right'" class="d-flex flex-column align-items-end">
            <div class="d-flex align-items-start justify-content-end gap-2 w-100">
              <div class="d-flex flex-column align-items-end gap-1 w-80">
                <span *ngIf="!fullWidthTimeline" class="text-end unified-title text-muted d-block mb-1">{{ getMessageDisplayName($any(item.data)) }}</span>
                <div *ngIf="hasSmsTextBubble($any(item.data))" class="sms-message-card sms-message-card--right card rounded-3 border p-2 px-3 position-relative m-0"
                     [class.sms-message-card--chat]="isPlainSmsChatMessage($any(item.data))">
                  <div class="d-flex flex-row flex-wrap align-items-center gap-2 w-100">
                    <div *ngIf="shouldShowSmsMessageBody($any(item.data)) || isOutboundCall($any(item.data))" class="small message-body flex-grow-1 min-w-0"><span *ngIf="isOutboundCall($any(item.data))" class="fw-bold me-2 fs-6">Outbound Call</span>{{ $any(item.data).body }}</div>
                    <div *ngIf="showCallRecordingPlayer($any(item.data))" class="call-recording-player flex-shrink-0" (click)="playOrPauseRecording(getRecordingUrl($any(item.data)))" title="Click to play/pause">
                      <button type="button" class="call-recording-play-btn rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" (click)="playOrPauseRecording(getRecordingUrl($any(item.data))); $event.stopPropagation()">
                        <i class="fa-solid text-white" [ngClass]="isRecordingPlaying(getRecordingUrl($any(item.data))) ? 'fa-pause' : 'fa-play'"></i>
                      </button>
                      <div class="waveform-container">
                        <span *ngFor="let h of waveformHeights" class="wave-bar" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))" [style.height.px]="h"></span>
                        <span class="wave-dot" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                        <span class="wave-dot wave-dot--sm" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                        <span class="wave-dot wave-dot--xs" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                      </div>
                      <span class="call-recording-duration">{{ getRecordingDisplayDuration(getRecordingUrl($any(item.data))) }}</span>
                    </div>
                    <div class="mms-attachment mt-2 w-100" *ngIf="getSmsMediaUrl($any(item.data)) && !isSmsImageFile($any(item.data))">
                      <a href="javascript:void(0)" class="media-link"
                        (click)="onSmsMediaClick($event, $any(item.data))"
                        [title]="getSmsAttachmentDisplayName($any(item.data))">
                        <i class="fa-solid" [ngClass]="smsMediaFileIcon($any(item.data))"></i>
                        <span class="media-filename">{{ getSmsAttachmentDisplayName($any(item.data)) }}</span>
                      </a>
                    </div>
                    <div *ngIf="!getSmsMediaUrl($any(item.data)) && $any(item.data).mediaFilename" class="message-media small text-muted flex-shrink-0">
                      <i class="fa-solid fa-paperclip me-1"></i>
                      {{ $any(item.data).mediaFilename }}
                    </div>
                  </div>
                </div>
                <div *ngIf="hasSmsImageAttachment($any(item.data))" class="sms-message-card sms-message-card--right sms-message-card--media-only m-0">
                  <div class="mms-attachment mms-attachment--image">
                    <button type="button" class="mms-thumbnail-btn"
                      (click)="onSmsMediaClick($event, $any(item.data))"
                      [title]="getSmsAttachmentDisplayName($any(item.data))">
                      <img [src]="getSmsMediaUrl($any(item.data))"
                        [alt]="getSmsAttachmentDisplayName($any(item.data))"
                        class="mms-thumbnail" loading="lazy" />
                    </button>
                  </div>
                </div>
                <ng-container
                  *ngIf="fullWidthTimeline; else smsRightDefaultDate"
                  [ngTemplateOutlet]="prospectHistoryMeta"
                  [ngTemplateOutletContext]="{ item: item }"
                ></ng-container>
                <ng-template #smsRightDefaultDate>
                  <small class="unified-date mt-1">
                    {{ formatMessageDate($any(item.data).createdAt || '') }}
                  </small>
                </ng-template>
              </div>
              <div class="sms-avatar sms-avatar--right my-auto rounded-circle d-flex align-items-center justify-content-center flex-shrink-0 bg-soft-primary">
                <ng-container
                  *ngTemplateOutlet="
                    unifiedFeedTimelineIcon;
                    context: {
                      iconType: timelineIconType($any(item.data)),
                      iconData: $any(item.data)
                    }
                  "
                ></ng-container>
              </div>
            </div>
          </div>
          <!-- Left: inbound calls, voicemail, missed, received SMS -->
          <div *ngSwitchCase="'left'" class="d-flex align-items-start gap-2">
            <div class="flex-grow-1">
              <div class="d-flex align-items-center gap-3">
                <div class="sms-avatar rounded-circle d-flex my-auto align-items-center justify-content-center flex-shrink-0 bg-soft-primary">
                  <ng-container
                    *ngTemplateOutlet="
                      unifiedFeedTimelineIcon;
                      context: {
                        iconType: timelineIconType($any(item.data)),
                        iconData: $any(item.data)
                      }
                    "
                  ></ng-container>
                </div>
                <div class="d-flex flex-column flex-grow-1 gap-1">
                  <span *ngIf="!fullWidthTimeline" class="unified-title text-muted d-block mb-1">{{ getMessageDisplayName($any(item.data)) }}</span>
                  <div *ngIf="hasSmsTextBubble($any(item.data))" class="sms-message-card sms-message-card--left card rounded-3 border p-2 px-3 m-0"
                       [class.sms-message-card--chat]="isPlainSmsChatMessage($any(item.data))">
                    <div class="d-flex flex-row flex-wrap align-items-center gap-2 w-100">
                      <div *ngIf="shouldShowSmsMessageBody($any(item.data)) || getReceivedSmsRowLabel($any(item.data)) !== 'SMS'" class="text-muted small message-body flex-grow-1 min-w-0">
                        <b *ngIf="getReceivedSmsRowLabel($any(item.data)) !== 'SMS'" class="me-2 fs-6 fw-bold">{{ getReceivedSmsRowLabel($any(item.data)) }}</b>{{ $any(item.data).body || '' }}
                      </div>
                      <div *ngIf="showCallRecordingPlayer($any(item.data))" class="call-recording-player flex-shrink-0" (click)="playOrPauseRecording(getRecordingUrl($any(item.data)))" title="Click to play/pause">
                        <button type="button" class="call-recording-play-btn rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" (click)="playOrPauseRecording(getRecordingUrl($any(item.data))); $event.stopPropagation()">
                          <i class="fa-solid text-white" [ngClass]="isRecordingPlaying(getRecordingUrl($any(item.data))) ? 'fa-pause' : 'fa-play'"></i>
                        </button>
                        <div class="waveform-container">
                          <span *ngFor="let h of waveformHeights" class="wave-bar" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))" [style.height.px]="h"></span>
                          <span class="wave-dot" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                          <span class="wave-dot wave-dot--sm" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                          <span class="wave-dot wave-dot--xs" [class.playing]="isRecordingPlaying(getRecordingUrl($any(item.data)))"></span>
                        </div>
                        <span class="call-recording-duration">{{ getRecordingDisplayDuration(getRecordingUrl($any(item.data))) }}</span>
                      </div>
                      <div class="mms-attachment mt-2 w-100" *ngIf="getSmsMediaUrl($any(item.data)) && !isSmsImageFile($any(item.data))">
                        <a href="javascript:void(0)" class="media-link"
                          (click)="onSmsMediaClick($event, $any(item.data))"
                          [title]="getSmsAttachmentDisplayName($any(item.data))">
                          <i class="fa-solid" [ngClass]="smsMediaFileIcon($any(item.data))"></i>
                          <span class="media-filename">{{ getSmsAttachmentDisplayName($any(item.data)) }}</span>
                        </a>
                      </div>
                      <div *ngIf="!getSmsMediaUrl($any(item.data)) && $any(item.data).mediaFilename" class="message-media small text-muted flex-shrink-0">
                        <i class="fa-solid fa-paperclip me-1"></i>
                        {{ $any(item.data).mediaFilename }}
                      </div>
                    </div>
                  </div>
                  <div *ngIf="hasSmsImageAttachment($any(item.data))" class="sms-message-card sms-message-card--left sms-message-card--media-only m-0">
                    <div class="mms-attachment mms-attachment--image">
                      <button type="button" class="mms-thumbnail-btn"
                        (click)="onSmsMediaClick($event, $any(item.data))"
                        [title]="getSmsAttachmentDisplayName($any(item.data))">
                        <img [src]="getSmsMediaUrl($any(item.data))"
                          [alt]="getSmsAttachmentDisplayName($any(item.data))"
                          class="mms-thumbnail" loading="lazy" />
                      </button>
                    </div>
                  </div>
                  <ng-container
                    *ngIf="fullWidthTimeline; else smsLeftDefaultDate"
                    [ngTemplateOutlet]="prospectHistoryMeta"
                    [ngTemplateOutletContext]="{ item: item }"
                  ></ng-container>
                  <ng-template #smsLeftDefaultDate>
                    <small class="unified-date d-block mt-1">
                      {{ formatMessageDate($any(item.data).createdAt || '') }}
                    </small>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <!-- Centered: join conversation (full-width line, same as sms-timeline) -->
          <div *ngSwitchCase="'center'" class="unified-feed-join-row w-100 text-center py-2 px-1">
            <span class="small text-muted unified-feed-join-text">
              <span class="unified-feed-join-name">{{ getMessageDisplayName($any(item.data)) }}</span> has joined the conversation<span *ngIf="$any(item.data).createdAt">, {{ formatMessageDate($any(item.data).createdAt || '') }}</span>
            </span>
          </div>
        </ng-container>
      </li>

      <!-- Events (by referral): same left-card design -->
      <li
        *ngIf="!nurseNotesTimeline && item.source === 'event'"
        class="my-5"
        [class.prospect-history-item]="fullWidthTimeline"
        [class.prospect-history-item--note]="fullWidthTimeline"
      >
        <div class="d-flex align-items-start gap-2">
          <div class="activity-avatar my-auto rounded-circle bg-soft-primary text-muted d-flex align-items-center justify-content-center flex-shrink-0">
            <img [src]="getEventIconSrc()" class="img-fluid unified-feed-type-icon" width="16" height="16" alt="" />
          </div>
          <div class="flex-grow-1">
            <span _ngcontent-usc-c214="" class="unified-title text-muted d-block mb-1 ng-star-inserted"
              style="min-height: 15px;"></span>
            <div class="activity-note-card activity-note-card--left card rounded-3 mb-0 border p-2 px-3">
              <div class="d-flex align-items-center justify-content-between gap-2 w-100">
                <span class="d-flex align-items-start gap-1 flex-grow-1 min-w-0">
                  <div class="text-muted small">
                    <span class="fs-6 fw-bold pe-1">Event:</span>
                    <span class="activity-note-tags-inline">{{ getEventTypeDisplay($any(item.data)) }}</span>
                  </div>
                </span>
              </div>
            </div>
            <ng-container
              *ngIf="fullWidthTimeline; else eventDefaultDate"
              [ngTemplateOutlet]="prospectHistoryMeta"
              [ngTemplateOutletContext]="{ item: item }"
            ></ng-container>
            <ng-template #eventDefaultDate>
              <small
                class="text-muted d-block mt-1"
                *ngIf="timelineItemDateDisplay(item) as when"
                >{{ when }}</small
              >
            </ng-template>
          </div>
        </div>
      </li>
    </ng-container>
  </ul>

  <div *ngIf="isLoading" class="unified-feed-loading px-3 py-2">
    <p-skeleton width="72%" height="3.5rem" styleClass="mb-3" />
    <p-skeleton width="58%" height="3.5rem" styleClass="mb-3" />
    <p-skeleton width="64%" height="3.5rem" />
  </div>
  <li
    *ngIf="!isLoading && mergedItems.length === 0"
    class="list-unstyled text-center py-3"
    [class.nurse-notes-empty]="nurseNotesTimeline"
    [class.text-muted]="!nurseNotesTimeline"
  >
    {{ nurseNotesTimeline ? 'No notes yet' : 'No activity yet' }}
  </li>
  <li *ngIf="!isLoading && mergedItems.length > 0 && filteredItems.length === 0" class="list-unstyled text-center py-3 text-muted">
    No matching activities
  </li>
  <div #scrollAnchor style="height: 1px;"></div>
</div>

<ng-template #unifiedFeedTimelineIcon let-iconType="iconType" let-iconData="iconData">
  <ng-container
    *ngIf="getEngageCallIconFontAwesomeClasses(iconType, iconData) as faCls; else unifiedFeedTimelineIconImg"
  >
    <i [class]="faCls + ' unified-feed-type-icon-fa'" aria-hidden="true"></i>
  </ng-container>
  <ng-template #unifiedFeedTimelineIconImg>
    <img
      [src]="getTimelineAvatarImgSrc(iconType, iconData)"
      class="img-fluid unified-feed-type-icon"
      width="16"
      height="16"
      alt=""
    />
  </ng-template>
</ng-template>
